/* eslint-disable import/no-cycle */
import React from 'react'

import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { requestCorporateTicketRefund } from 'actions/common/ticketRefund'
import WaitingImage from 'assets/waiting-image.svg'
import InternationalRefundForm from 'components/forms/refund-form/international-refund/internationalRefundForm'
import { ResultWrapper } from 'components/forms/styled'
import StatusMessage from 'components/status-message'
import { generateHomeRoute } from 'helpers/url/localization'
import NAMESPACES from 'localization/constants/namespaces'
import { formSuccess } from 'selectors/common/contactUs'

import { RefundContainer } from './styled'

const RefundRequest = props => {
  const {
    t,
    i18n: { language }
  } = useTranslation(NAMESPACES.USA_FORM)
  const history = useHistory()

  const showMessageSuccess = () => (
    <ResultWrapper>
      <StatusMessage
        onClickHandler={() => history.push(generateHomeRoute(language))}
        buttonLabel={t('usaForms.go-to-home-button')}
        title={t('agreements.refund-request.result-success.title')}
        description={t('agreements.refund-request.result-success.description')}
        srcImage={WaitingImage}
      />
    </ResultWrapper>
  )

  return (
    <RefundContainer>
      {props.formSuccess ? (
        showMessageSuccess()
      ) : (
        <InternationalRefundForm requestRefund={props.requestCorporateTicketRefund} />
      )}
    </RefundContainer>
  )
}

const mapStateToProps = state => ({
  formSuccess: formSuccess(state)
})

const mapDispatchToProps = {
  requestCorporateTicketRefund
}

export default connect(mapStateToProps, mapDispatchToProps)(RefundRequest)
